module.exports = __webpack_public_path__ + "static/media/vote.eb1b7ccf.jpg";